import { inject } from '@angular/core';
import {
  collection,
  collectionData,
  CollectionReference,
  Firestore,
} from '@angular/fire/firestore';
import { Province } from '@domain/aggregates';
import { ProvincesDataSource } from './provinces.datasource';

export class FirebaseProvincesDataSource extends ProvincesDataSource {
  readonly #firestore = inject(Firestore);
  readonly #collection = collection(
    this.#firestore,
    'provinces'
  ) as CollectionReference<Province>;

  listProvinces() {
    return collectionData(this.#collection);
  }
}
